export function getLocalStorageValue(key) {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : {};
  } catch {
    return {};
  }
}

export function updateLocalStorageValue(key, newValue) {
  if (newValue) localStorage.setItem(key, JSON.stringify(newValue));
  else localStorage.removeItem(key);
}

export function getLocalStorageArrayValue(key) {
  try {
    const item = localStorage.getItem(key);
    if (!item) return [];
    const array = JSON.parse(item);
    return Array.isArray(array) ? array : [];
  } catch {
    return [];
  }
}